import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/tasks";
import Kanban from "./kanban";
import Show from "./show";
import List from "./table";

export default function Tasks(props) {
    useEffect(() => {
        return () => props.clearParams("tasks");
    }, []);

    const { match, location, history } = props;
    const back = () => history.push(paths.tasks);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={paths.tasksKanban} />} />
                <Route
                    exact
                    path={`${match.path}/kanban`}
                    render={() => <Kanban {...props} isTable nofilter transition="full" title="Задачи" />}
                />
                <Route
                    exact
                    path={`${match.path}/table`}
                    render={() => <List {...props} isTable nofilter transition="full" title="Задачи" source={source} />}
                />
                <Route
                    exact
                    path={`${match.path}/:id`}
                    render={(rest) => (
                        <Show
                            {...rest}
                            transition="full"
                            title="Задача"
                            back={back}
                            source={{ ...source, apply: source.complete }}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}
